// PatternRecognitionGame.jsx
import React, { useState, useEffect } from 'react';

const patternStyles = {
  body: {
    fontFamily: 'Comic Sans MS, cursive',
    background: 'linear-gradient(to right, #E1F5FE, #FFF9C4)',
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    overflow: 'hidden',
    animation: 'fadeIn 1.2s ease'
  },
  gameBox: {
    background: '#ffffff',
    padding: '40px',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    maxWidth: '600px',
    width: '90%'
  },
  heading: {
    fontSize: '2.2rem',
    color: '#00796B',
    marginBottom: '20px'
  },
  pattern: {
    fontSize: '2.5rem',
    marginBottom: '25px'
  },
  options: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '20px'
  },
  button: {
    backgroundColor: '#FFF59D',
    border: '2px solid #FBC02D',
    borderRadius: '16px',
    padding: '15px 25px',
    fontSize: '1.8rem',
    cursor: 'pointer',
    transition: 'background 0.3s, transform 0.3s'
  },
  feedback: {
    marginTop: '30px',
    fontSize: '1.6rem',
    fontWeight: 'bold',
    minHeight: '40px'
  },
  nextBtn: {
    marginTop: '30px',
    padding: '10px 25px',
    backgroundColor: '#81D4FA',
    color: '#01579B',
    fontSize: '1.2rem',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer'
  }
};

const questions = [
  { pattern: '🍓🍇🍓🍇❓', answer: '🍓', options: ['🍇', '🍓', '🍌'] },
  { pattern: '🟥🟦🟥🟦❓', answer: '🟥', options: ['🟥', '🟩', '⬛'] },
  { pattern: '🍌🍌🍎🍌🍌❓', answer: '🍎', options: ['🍌', '🍎', '🍊'] },
  { pattern: '⬛⬜⬛⬜❓', answer: '⬛', options: ['⬛', '⬜', '🟥'] },
  { pattern: '🔵🟢🔵🔵🟢🔵🔵🔵❓', answer: '🟢', options: ['🔵', '🟢', '🟥'] },
  { pattern: '🍉🍉🍋🍋🍉🍉❓', answer: '🍋', options: ['🍉', '🍋', '🍎'] },
  { pattern: '🔴🟠🟡🔴🟠❓', answer: '🟡', options: ['🟢', '🟡', '🔵'] },
  { pattern: '🍇🍇🍓🍇🍇❓', answer: '🍓', options: ['🍇', '🍓', '🍊'] },
  { pattern: '⬜⬜⬛⬜⬜⬛⬜❓', answer: '⬜', options: ['⬛', '⬜', '🟥'] },
  { pattern: '🔷🔶🔷🔶🔷❓', answer: '🔶', options: ['🔷', '🔶', '🟥'] }
];

export default function PatternRecognitionGame() {
  const [current, setCurrent] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('#6A1B9A');

  const checkAnswer = (selected) => {
    const correct = questions[current].answer;
    if (selected === correct) {
      setFeedback('✅ Correct! You spotted the pattern!');
      setFeedbackColor('#2E7D32');
    } else {
      setFeedback('❌ Try again! Patterns take practice!');
      setFeedbackColor('#C62828');
    }
  };

  const nextQuestion = () => {
    setCurrent((prev) => (prev + 1) % questions.length);
    setFeedback('');
    setFeedbackColor('#6A1B9A');
  };

  return (
    <div style={patternStyles.body}>
      <div style={patternStyles.gameBox}>
        <h1 style={patternStyles.heading}>🔍 Guess the Pattern!</h1>
        <div style={patternStyles.pattern}>{questions[current].pattern}</div>
        <div style={patternStyles.options}>
          {questions[current].options.map((opt) => (
            <button
              key={opt}
              style={patternStyles.button}
              onClick={() => checkAnswer(opt)}
            >
              {opt}
            </button>
          ))}
        </div>
        <div style={{ ...patternStyles.feedback, color: feedbackColor }}>{feedback}</div>
        <button style={patternStyles.nextBtn} onClick={nextQuestion}>
          Next Pattern ➡️
        </button>
      </div>
    </div>
  );
}
